module.exports = __webpack_public_path__ + "img/logo-mitama.a1ae75eb.png";